module.exports = __webpack_public_path__ + "img/colearning-branco-300x299.229d155e.png";